import React, { useEffect, useState } from 'react'
import { Autocomplete, makeStyles } from '@cicero/ui'
import { IFormElementProps, createSyntheticChangeEvent, useAutocompleteConfig } from '@cicero/ui/forms'
import { AttributeDoc, AttributeValueDoc, PageDoc, PageSchema, useModel } from 'models'
import { PageLinkRenderer } from 'views/PageLink'

interface IPageChooserProps extends IFormElementProps<PageDoc|null> {
  label?: string
  alwaysOpen?: boolean
  autoFocus?: boolean
  selectedValues?: AttributeValueDoc[]
}

export const PageChooser = ({ name, value, onChange, ...restOfParams }: IPageChooserProps) => {
  const Pages = useModel(PageSchema)
  const [options, setOptions] = useState<PageDoc[]>([])

  useEffect(() => {
    const sub = Pages.QUERY$({ selector: {} })
      .subscribe(pages => {
        setOptions(pages)
        // if (selectedValues && selectedValues.length) {

        // }
      })
    return () => sub.unsubscribe()
  }, [])

  return <Autocomplete
    {...useAutocompleteConfig(restOfParams)}
    value={value}
    options={options}
    getOptionLabel={(page: PageDoc) => page.title || 'Untitled'}
    onChange={(event, newVal) => {
      onChange(createSyntheticChangeEvent(name, newVal))
    }}
  />
}

export const PageOptionRenderer = ({ values }: { attribute?: AttributeDoc, values: AttributeValueDoc[] }) => {
  const { pageList } = useStyles()
  return values.length ? <ul className={pageList}>{values.map((val, i) => <li key={i}>
    <PageLinkRenderer id={val.linked_page_id} />
  </li>)}</ul> : null
}

const useStyles = makeStyles({
  pageList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
})
